// export const mutations =    => {
export const payload = (state, val) => {
    state.payload = val
}

export const mPGSCardUsed = (state, val) => {
    state.mPGSCardUsed = val
}

export const service_call_payload = (state, val) => {
    state.service_call_payload = val
}


export const showDefaultView = (state, val) => {
    state.showDefaultView = val
}

export const paymentMethod = (state, val) => {
    state.paymentMethod = val
}

export const api_key = (state, val) => {
    state.api_key = val
}

export const cardDetails = (state, val) => {
    state.cardDetails = val
}

export const card_cc = (state, val) => {
    state.card_cc = val
}

export const card_exp = (state, val) => {
    state.card_exp = val
}

export const card_cvv = (state, val) => {
    state.card_cvv = val
}

export const options = (state, val) => {
    state.options = val
}

export const isLoading = (state, val) => {
    state.isLoading = val
}

export const channels = (state, val) => {
    state.channels = val
}

export const isFailed = (state, val) => {
    state.isFailed = val
}

export const transRef = (state, val) => {
    state.transRef = val
}

export const parentTransRef = (state, val) => {
    state.parentTransRef = val
}

export const provider = (state, val) => {
    state.provider = val
}

export const paymentMethodIndex = (state, val) => {
    state.paymentMethodIndex = val
}

export const popupReferrer = (state, val) => {
    state.popupReferrer = val
}

export const client_info = (state, val) => {
    state.client_info = val
}

export const app_info = (state, val) => {
    state.app_info = val
}

export const optionsTransRef = (state, val) => {
    state.optionsTransRef = val
}


export const paymentMethodProvider = (state, val) => {
    state.paymentMethodProvider = val
}

export const customer_processing_fee = (state, val) => {
    state.customer_processing_fee = val
}





// };